import React, { useState } from "react";
import { Lock, ShieldCheck, User } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

export default function Login() {
  const { login, loading } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    setErr("");
    try { await login(username, password); }
    catch (ex) { setErr(ex.response?.data?.detail || "Login failed"); }
  }

  return (
    <div className="min-h-screen relative flex items-center justify-center p-4 bg-hero-mesh overflow-hidden">
      {/* Animated mesh shimmer overlay */}
      <div className="absolute inset-0 bg-hero-mesh animate-mesh-drift opacity-80" />
      <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-black/10 to-black/30" />

      <div className="relative w-full max-w-md animate-fade-in">
        {/* Floating brand mark above the card */}
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white/15 backdrop-blur-md ring-1 ring-white/30 shadow-elevated mb-3">
            <ShieldCheck className="text-white" size={32} />
          </div>
          <h1 className="text-3xl font-bold text-white tracking-tight">Hima Cement</h1>
          <p className="text-white/80 mt-1 text-sm">IT Service Management Portal</p>
        </div>

        {/* Glassmorphism card */}
        <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-elevated ring-1 ring-white/20 overflow-hidden">
          <form onSubmit={onSubmit} className="p-7 space-y-4">
            <div>
              <label className="block text-sm font-semibold text-white/90 mb-2">Username</label>
              <div className="relative">
                <User size={16} className="absolute left-3.5 top-3.5 text-white/60" />
                <input
                  className="w-full bg-white/15 backdrop-blur-sm border border-white/20 rounded-lg pl-10 pr-3 py-3 text-white placeholder:text-white/50 focus:outline-none focus:ring-2 focus:ring-white/40 focus:border-white/40 transition"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="your.username"
                  required
                  autoFocus
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-semibold text-white/90 mb-2">Password</label>
              <div className="relative">
                <Lock size={16} className="absolute left-3.5 top-3.5 text-white/60" />
                <input
                  type="password"
                  className="w-full bg-white/15 backdrop-blur-sm border border-white/20 rounded-lg pl-10 pr-3 py-3 text-white placeholder:text-white/50 focus:outline-none focus:ring-2 focus:ring-white/40 focus:border-white/40 transition"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
              </div>
            </div>

            {err && (
              <div className="text-sm text-rose-100 bg-rose-500/30 border border-rose-300/40 rounded-lg px-3 py-2">
                {err}
              </div>
            )}

            <button
              className="w-full py-3 rounded-lg font-semibold text-brand-700 bg-white hover:bg-white/95 shadow-elevated transition disabled:opacity-60"
              disabled={loading}
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>

        <p className="text-center text-white/70 text-xs mt-5">
          Hima Cement IT Service Desk · Need help? Contact <span className="text-white">itsm.support@himacement.com</span>
        </p>
      </div>
    </div>
  );
}
